module.exports = __webpack_public_path__ + "static/media/zhengs2-1@3x.2317f8c2.png";